import type { MinimalUser } from '@/generated/model';

export function requiresForcedPasswordChange(user: MinimalUser) {
  return !user.isTokenUser && user.forcePasswordChange;
}
